<div class="logo"
  [style.width]="width + 'px'"
  [ngClass]="{ 'dark-logo': type === 'dark', 'light-logo': type === 'light' }">
</div>
